import axios from "services/axios";
import {useMutation} from "react-query";

export const uploadFile = values => axios.post("/misc/s3-upload", values).then(res => res.data);

export function useUploadFile() {
	return useMutation(uploadFile);
}
